import { render, staticRenderFns } from "./ShippingRuleTab.vue?vue&type=template&id=fa389036&scoped=true&"
import script from "./ShippingRuleTab.vue?vue&type=script&lang=js&"
export * from "./ShippingRuleTab.vue?vue&type=script&lang=js&"
import style0 from "./ShippingRuleTab.vue?vue&type=style&index=0&id=fa389036&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa389036",
  null
  
)

export default component.exports